import { userConstants } from 'Constants/user.constants';

const initialState = { loading: false };

export function userlogout(state = initialState, action={}) {
  const { autoLogout = false } = action;
  switch (action.type) {
    case userConstants.LOGOUT_REQUEST:
      return { loading: true, error:null, autoLogout: autoLogout };
    case userConstants.LOGOUT_SUCCESS:
      return { loading: false, error:false, autoLogout: autoLogout };
    case userConstants.LOGOUT_FAILURE:
      return { loading: false, error:true, autoLogout: autoLogout };
    default:
      return state;
  }
}
